/**
 * Where a permission failure lands. Lives beside the guard rather than in the
 * feature, so `permissionsGuard` does not have to reach into `@features/*` for
 * the one thing it needs from it.
 */
export const FORBIDDEN_ROUTE = '/forbidden';
